import { useCallback, useEffect, useState } from 'react';
import { API_BASE_URL } from '../config.js';

/**
 * Analyses of a report: list, load state ('loading' | 'ready' | 'error') and reload.
 * Owned by the report page, which needs their count on every tab (sidebar badge).
 * `initial` (public view) is a static list: nothing is fetched. `refreshKey` refetches
 * while the analyzer runs.
 */
export const useReportAnalyses = ({ enabled = true, fetchWithAuth, clientSlug, weekId, initial = null, refreshKey = '' }) => {
  const [analyses, setAnalyses] = useState(initial || []);
  const [loadState, setLoadState] = useState(initial ? 'ready' : 'loading');
  const isStatic = !!initial;

  const reload = useCallback(async () => {
    if (!enabled || isStatic) return;
    try {
      const response = await fetchWithAuth(`${API_BASE_URL}/api/weekly/client/${clientSlug}/week/${weekId}/analyses`);
      const data = await response.json();
      if (!response.ok || !Array.isArray(data)) throw new Error('analyses unavailable');
      setAnalyses(data);
      setLoadState('ready');
    } catch (err) {
      console.error('Error loading analyses:', err);
      // A failed refresh keeps what is on screen; only a first load turns into an error.
      setLoadState((state) => (state === 'ready' ? state : 'error'));
    }
  }, [enabled, isStatic, fetchWithAuth, clientSlug, weekId]);

  useEffect(() => {
    reload();
  }, [reload, refreshKey]);

  return { analyses, setAnalyses, loadState, setLoadState, reload };
};

export default useReportAnalyses;
